import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import OrderRecovery from './Components/OrderCheckout/OrderRecovery';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';
import BasketContextProvider from './Components/Context/BasketContext';

function OrderRecoveryRoute() {
    return (
        <UserInfoProvider>
            <BasketContextProvider>
                <MedicalContextProvider>
                    <div className="OrderRecoveryRoutePage">
                        <div className="OrderRecoveryRouteNavBar">      
                            <NavBar/>
                        </div>
                        <div className="OrderRecoveryRoute">
                            <OrderRecovery/>
                        </div>
                        {/*<div className="OrderDownloadRouteFooter">      
                            <Footer/>
                        </div>*/}
                    </div>
                </MedicalContextProvider>
            </BasketContextProvider>
        </UserInfoProvider>
    );
}

export default OrderRecoveryRoute;